import { ReactNode } from 'react'
import './Paragraph.scss'
interface Props {
  children: ReactNode
}
export const Paragraph = ({ children }: Props) => {
  return <p className="cms-paragraph">{children}</p>
}
